import { sendStats } from '../stats.js';
import { project } from '../initializeStats.js';
import { scrollToEvent } from '../helpers.js';

const sendVote = async (url, data) => {
	const response = await fetch(url, {
		method: 'POST',
		body: data,
	});
	if (!response.ok) {
		throw new Error(`Server responded with status: ${response.status}`);
	}
	return response.text();
};

const reportVote = (candidate) => {
	const eventAction = 'ontouchstart' in document.documentElement ? 'tap' : 'click';
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
		event: 'site_interaction',
		eventCategory: 'send_form',
		eventAction,
		eventLabel: candidate,
	});
	sendStats('send_form', eventAction, candidate);
};

const showError = (form) => {
	const errorMessage = document.createElement('div');
	errorMessage.classList.add('error-message');
	errorMessage.innerText = 'Nie udało się oddać głosu. Proszę spróbować ponownie.';
	form.append(errorMessage);
	setTimeout(() => errorMessage.remove(), 5000);
};

export const voting = () => {
	document.querySelectorAll('.voting__form').forEach((form) => {
		const voting = form.closest('.voting');
		const url = form.dataset.entryUrl;
		const buttons = form.querySelectorAll('.candidate__button');

		form.addEventListener('submit', async (e) => {
			e.preventDefault();
			if (!url) {
				console.log('Fatal error - no form entry url');
				return;
			}

			const button = e.submitter;
			const candidate = button?.closest('.candidate');
			if (!candidate) return;

			const data = new FormData(form, button);
			data.append('button', 'submit');
			data.append('form_placement', 'site');

			candidate.classList.add('__js_selected');
			buttons.forEach((btn) => { btn.disabled = true; });

			try {
				const html = await sendVote(url, data);
				reportVote(button.value);
				voting.innerHTML = `<div class="voting__response">${html}</div>`;
				project.isScrollingController(true);
				scrollToEvent(voting.getBoundingClientRect().top + window.scrollY - document.querySelector('.header').offsetHeight, () => {
					project.isScrollingController(false);
				});
			} catch (err) {
				console.log('Error', err);
				candidate.classList.remove('__js_selected');
				buttons.forEach((btn) => { btn.disabled = false; });
				showError(form);
			}
		});
	});
};
